import React from 'react';
import './Dec6_Industries_BgImage_CSS.css';

function Dec6_Industries_BgImage() {
    return(
        <div className="Dec6_Industries_BgImage_Block">

        </div>
    );
}

export default Dec6_Industries_BgImage;